exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-videochat-plugin,#asseco-videochat .asseco-floaty-btn{background-color:#455a64}", ""]);

// exports
